/* Fit the equipment itself, rather than each source image's white margins. */
(() => {
  const records = new WeakMap();
  const frames = new WeakMap();
  function measure(image) {
    const ratio = Math.min(192 / image.naturalWidth, 192 / image.naturalHeight);
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(image.naturalWidth * ratio));
    canvas.height = Math.max(1, Math.round(image.naturalHeight * ratio));
    const context = canvas.getContext('2d', { willReadFrequently: true });
    if (!context) return null;
    context.fillStyle = '#fff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
    const white = (x, y) => {
      const index = (y * canvas.width + x) * 4;
      return pixels[index] >= 238 && pixels[index + 1] >= 238 && pixels[index + 2] >= 238;
    };
    // Lifestyle photos retain their complete image; trim only white product backgrounds.
    const corners = [[0, 0], [canvas.width - 1, 0], [0, canvas.height - 1], [canvas.width - 1, canvas.height - 1]];
    if (!corners.every(([x, y]) => white(x, y))) return null;
    let left = canvas.width, right = -1, top = canvas.height, bottom = -1;
    for (let y = 0; y < canvas.height; y++) {
      for (let x = 0; x < canvas.width; x++) {
        if (!white(x, y)) {
          left = Math.min(left, x); right = Math.max(right, x);
          top = Math.min(top, y); bottom = Math.max(bottom, y);
        }
      }
    }
    if (right - left < 4 || bottom - top < 4) return null;
    return { left: left / ratio, top: top / ratio, width: (right - left + 1) / ratio, height: (bottom - top + 1) / ratio };
  }
  function fit(image, frame) {
    const bounds = records.get(image);
    if (!bounds || !frame.clientWidth || !frame.clientHeight) return;
    const width = Math.min(frame.clientWidth - 40, 360);
    const height = frame.clientHeight - 32;
    const scale = Math.min(width / bounds.width, height / bounds.height);
    image.style.width = image.naturalWidth * scale + 'px';
    image.style.height = image.naturalHeight * scale + 'px';
    image.style.left = (frame.clientWidth - bounds.width * scale) / 2 - bounds.left * scale + 'px';
    image.style.top = (frame.clientHeight - bounds.height * scale) / 2 - bounds.top * scale + 'px';
    image.dataset.xrNormalized = 'true';
  }
  const observer = window.ResizeObserver ? new ResizeObserver(entries => {
    entries.forEach(({ target }) => fit(frames.get(target), target));
  }) : null;
  function initialize(scope) {
    scope.querySelectorAll('.xr-collection-subnav .collection-image img').forEach(image => {
      const frame = image.closest('.collection-image');
      if (frames.has(frame)) return;
      frames.set(frame, image);
      const loaded = () => {
        try { records.set(image, measure(image)); } catch { records.set(image, null); }
        fit(image, frame);
      };
      image.addEventListener('load', loaded);
      if (image.complete && image.naturalWidth) loaded();
      if (observer) observer.observe(frame);
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
